<script setup>
import { ref } from "vue";

import AgentSelectorIcon from "@/assets/icons/navigation/AgentSelectorIcon.vue";

const agentMenu = ref(null);

function toggleAgentMenu(event) {
  agentMenu.value.toggle(event);
}

const overlayMenuItems = ref([
  {
    label: "Vesper",
  },
  {
    label: "Arion",
  },
  {
    label: "Selene",
  },
  {
    separator: true,
  },
  {
    label: "Create new agent",
  },
]);
</script>

<template>
  <Menu ref="agentMenu" :model="overlayMenuItems" :popup="true" />
  <div
    class="flex items-center space-x-2 relative border border-transparent hover:border-surface-300 dark:hover:border-surface-600 pl-3 rounded-md cursor-pointer"
    @click="toggleAgentMenu"
  >
    <span class="font-medium text-neena-darkgreen-500 dark:text-surface-100"
      >mail-bot</span
    >
    <AgentSelectorIcon />
  </div>
</template>
